import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useSimilarGenerators = ({
  generatorId,
  subjects,
  grades,
}: {
  generatorId?: string;
  subjects?: string[];
  grades?: string[];
}) => {
  const { data, isFetching: isFetchingSimilarGenerators } = useQuery(
    ['similar-generators', generatorId],
    async () => {
      return backendService.instance.generators.listByGradeAndSubject({
        limit: 20,
        cursor: 0,
        subjects: subjects || [],
        grades: grades || [],
      });
    },
    {
      staleTime: 1000 * 60 * 5,
      enabled: !!generatorId,
    },
  );

  return {
    similarGenerators: data?.items || [],
    isFetchingSimilarGenerators,
  };
};
